module.exports = __webpack_public_path__ + "img/arrowup_ic.1c5ce03c.svg";